import { Userbot } from "../../interfaces"

export function buildFeedRows(
  items: Userbot.AccountFeedItem[],
): Userbot.FeedRow[] {
  const rows: Userbot.FeedRow[] = []
  items.forEach((account, rowIndex) => {
    const accountKey = account.id ?? `pending-${rowIndex}`
    const accountRowId = accountKey
    rows.push({
      kind: "account",
      item: account,
      rowId: accountRowId,
      accountKey,
    })
    account.clients.forEach((client) => {
      rows.push({
        kind: "client",
        item: client,
        account,
        rowId: `${accountKey}:${client.id}`,
        parentRowId: accountRowId,
      })
    })
  })
  return rows
}
